import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import {http} from '@/network/http'
import VueClipboard from 'vue-clipboard2'

if (process.env.NODE_ENV === 'development') {
    require('./assets/css/image.css')
}

Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.use(VueClipboard)

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
